import { logUsage } from 'owa-analytics';
import type { ProviderType } from 'owa-graph-schema';

type KnownProviderType = Exclude<ProviderType, 'Other'>;
const providerTypesMap: Record<string, KnownProviderType> & {
    [K in Lowercase<KnownProviderType>]: KnownProviderType;
} = {
    // Handle common provider types
    onedrivepro: 'OneDrivePro',
    onedriveconsumer: 'OneDriveConsumer',
    dropbox: 'Dropbox',
    box: 'Box',
    mailbox: 'Mailbox',
    gdrive: 'GDrive',
    facebook: 'Facebook',
    wopibox: 'WopiBox',
    wopiegnyte: 'WopiEgnyte',
    wopidropbox: 'WopiDropbox',
    mailmessage: 'MailMessage',
};

export function convertProviderTypeToGQL(providerType: string | undefined): ProviderType {
    const caseInsensitiveProviderType = providerType?.toLowerCase();

    if (!!caseInsensitiveProviderType && caseInsensitiveProviderType in providerTypesMap) {
        return providerTypesMap[caseInsensitiveProviderType];
    }

    logUsage('CnexErrorUnexpectedProviderTypeInGqlResolver', { providerType });
    return 'Other';
}
